module.exports = __webpack_public_path__ + "img/traffic.d73fd7e8.jpg";